import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FF4B55"
  }} d="M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v28.745h512v-28.745  C512,105.443,494.833,88.276,473.655,88.276z" /><rect y={155.37} style={{
    fill: "#F5F5F5"
  }} width={512} height={67.09} /><g><rect y={222.46} style={{
      fill: "#FF4B55"
    }} width={512} height={67.09} /><path style={{
      fill: "#FF4B55"
    }} d="M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345   v-28.745H0V385.379z" /></g><rect y={289.55} style={{
    fill: "#F5F5F5"
  }} width={512} height={67.09} /><path style={{
    fill: "#41479B"
  }} d="M13.7,414.748l233.898-153.244c3.966-2.599,3.966-8.412,0-11.009L13.7,97.251  C5.326,104.286,0,114.829,0,126.621V385.38C0,397.171,5.326,407.714,13.7,414.748z" /><path style={{
    fill: "#F5F5F5"
  }} d="M90.183,215.026l9.213,27.623l29.118,0.226c3.769,0.029,5.333,4.84,2.301,7.08l-23.424,17.298  l8.783,27.763c1.138,3.594-2.955,6.568-6.023,4.375l-23.689-16.932l-23.69,16.932c-3.066,2.193-7.159-0.781-6.023-4.375  l8.783-27.763l-23.424-17.299c-3.032-2.24-1.47-7.05,2.301-7.08l29.118-0.226l9.213-27.623  C83.932,211.449,88.99,211.449,90.183,215.026z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };